import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { removeNotification } from '../../slice/SnackbarSlice';
import ErrorToast from './ErrorToast';

const GlobalErrorToast = () => {
  const errorMessages = useSelector((state) => state.snackbar.errorMessages);
  const dispatch = useDispatch();

  const handleClose = (id) => {
    dispatch(removeNotification(id));
  };

  if (!errorMessages || errorMessages.length === 0) {
    return null;
  }

  return <ErrorToast message={errorMessages} onClose={handleClose} />;
};

export default GlobalErrorToast;
